import type { VendorReview } from '@/pages/detail/types';

interface ReviewItemProps {
  review: VendorReview;
}

export default function ReviewItem({ review }: ReviewItemProps) {
  const initial = (review.author || review.source || review.title || '후').charAt(0);

  return (
    <div className="bg-static-white border border-[#E1DBD4] rounded-2xl p-5 md:p-6">
      <div className="flex items-center gap-3 mb-3">
        <div className="w-9 h-9 rounded-full bg-[#F5F3F0] flex items-center justify-center text-[#3F3A35] text-caption font-medium overflow-hidden">
          {review.writerProfileImageUrl ? (
            <img
              src={review.writerProfileImageUrl}
              alt={`${review.author} 프로필`}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          ) : (
            initial
          )}
        </div>
        <div>
          <div className="flex items-center gap-2">
            <p className="text-[15px] font-semibold text-[#211C18]">{review.author}</p>
            {review.category && (
              <span className="px-1.5 py-0.5 rounded text-[12px] font-medium bg-[#F5F3F0] text-[#5F5953] leading-none">
                {review.category}
              </span>
            )}
          </div>
          <p className="text-label2 text-[#7A736C]">{review.date}</p>
        </div>
      </div>

      {review.title && (
        <p className="text-[15px] font-semibold text-[#211C18] mb-2">{review.title}</p>
      )}

      <p className="text-body2 text-[#3F3A35] leading-[1.68] md:max-w-[720px] line-clamp-2">
        {review.content}
      </p>

      {review.photoUrls && review.photoUrls.length > 0 && (
        <div className="flex gap-2 mt-3">
          {review.photoUrls.slice(0, 3).map((url, i) => (
            <div key={`${review.id}-${url}-${i}`} className="w-[72px] h-[72px] rounded-lg overflow-hidden flex-shrink-0">
              <img src={url} alt={`리뷰 사진 ${i + 1}`} className="w-full h-full object-cover" loading="lazy" />
            </div>
          ))}
        </div>
      )}

      {review.originalUrl && (
        <div className="flex justify-starg mt-4">
          <a
            href={review.originalUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 mt-2.5 text-xs text-[#5F5953] hover:text-[#B4563F] transition-colors cursor-pointer"
          >
            카페글로 이동 <i className="ri-external-link-line text-[10px]"></i>
          </a>
        </div>
      )}
    </div>
  );
}
